/*
{
  url: string -- 이동하려는 주소('/project/1') 또는 라우터 이름({name:'', params:{id:1}})
}
*/
export default [
  {
    url: {name: 'project-home', params:{proj_id: 1}},
    name: '중대재해예방부서',
    icon: 'AlertTriangleIcon',
    activeCode: '',
    project_type: '총괄관리',
  },
  {
    url: {name: 'project-home', params:{proj_id: 2}},
    name: '제조업',
    icon: 'PackageIcon',
    activeCode: '',
    project_type: '내부종사자',
  },
  {
    url: {name: 'project-home', params:{proj_id: 3}},
    name: '기타 서비스업',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '도급',
  },
  {
    url: {name: 'project-home', params:{proj_id: 4}},
    name: '건설업',
    icon: 'TriangleIcon',
    activeCode: '',
    project_type: '발주',
  },
  {
    url: {name: 'project-home', params:{proj_id: 5}},
    name: '시설물 관리업',
    icon: 'ShieldIcon',
    activeCode: '',
    project_type: '중대시민재해',
  },
  {
    url: {name: 'project-home', params:{proj_id: 6}},
    name: '교육 서비스업',
    icon: 'BookOpenIcon',
    activeCode: '',
    project_type: '중대시민재해',
  }
]
